import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 26 26",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M3.5 5v15.7h19V7.2H12.162a2.5 2.5 0 0 1-1.673-.642L8.758 5zm6.119-1.243 1.874 1.686a1 1 0 0 0 .668.257H23a1 1 0 0 1 1 1v14.5a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4.5a1 1 0 0 1 1-1h5.95a1 1 0 0 1 .669.257",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M11.668 11.768a1.268 1.268 0 1 1-2.536 0 1.268 1.268 0 0 1 2.536 0m1.5 0a2.768 2.768 0 1 1-5.536 0 2.768 2.768 0 0 1 5.536 0m-5.793 6.277a1.5 1.5 0 0 1 1.5-1.5h3.001a1.5 1.5 0 0 1 1.5 1.5v.267a.75.75 0 1 0 1.5 0v-.267a3 3 0 0 0-3-3H8.875a3 3 0 0 0-3 3v.267a.75.75 0 0 0 1.5 0zm9.015-5.008a.764.764 0 1 0-.001-1.53.764.764 0 0 0 0 1.53m0 1.5a2.264 2.264 0 1 0-.001-4.529 2.264 2.264 0 0 0 0 4.529m-.657.508a.75.75 0 1 0 0 1.5h2a1 1 0 0 1 1 1v.263a.75.75 0 0 0 1.5 0v-.263a2.5 2.5 0 0 0-2.5-2.5z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=WorkspacesIcon26.js.map